<template>
    <div v-if="current">
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field
          label="Potência Mínima"
          v-model="query" 
          @click:append="search()" 
          append-icon="mdi-magnify" 
          v-on:keyup.enter="search()"
          solo dense
        ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-alert dense text type="info">
                {{ counter }} registros encontrados
                </v-alert>
            </v-col>
        </v-row>
        <v-simple-table>
            <thead>
                <tr>
                    <th>Serial</th>
                    <th>Power</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in current" :key="item.id">
                    <td>{{ item.serial }}</td>
                    <td>{{ item.power }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <v-dialog v-model="dialog_loading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Por favor aguarde
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: [],
    counter: 0,
    query: '',
    dialog_loading: false
  }),
  methods: {
    search: function(){
    var me = this;
    me.dialog_loading = true;
      var token = localStorage.getItem("token");
      api
        .get("/ont/power/min/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
          me.counter = me.current.length;
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          me.dialog_loading = false;
        });
    }
  }
}
</script>